export default __webpack_public_path__ + "static/media/denise-artworkinfo3.dcc5f440.jpeg";